import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import dieSizeService from "../services/die-size.service";
import { setMessage } from "./message";
export const fetchDieSizeList = createAsyncThunk(
    'diesize/fetchDieSizeList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await dieSizeService.getSizeList(page, pagesize, search, ordering);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const fetchDieSizeDropdown = createAsyncThunk(
    'diesize/fetchDieSizeDropdown',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await dieSizeService.getDieSizeList(page, pagesize, search, ordering);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const fetchArchivedDieSizeList = createAsyncThunk(
    'diesize/fetchArchiveDieSizeList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await dieSizeService.getDieArchiveSizeList(page, pagesize, search, ordering);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const createDieSize = createAsyncThunk(
    'diesize/createDieSize',
    async (sizeData, thunkAPI) => {
        try {
            const response = await dieSizeService.createSize(sizeData);
            return response.results; // Assuming response contains the created die size data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const editDieSize = createAsyncThunk(
    'diesize/editDieSize',
    async ({ SizeId, SizeData }, thunkAPI) => {
        try {
            const response = await dieSizeService.editDieSize(SizeId, SizeData);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteDieSize = createAsyncThunk(
    'dieSize/deleteDieSize',
    async (id, thunkAPI) => {
        try {
            await dieSizeService.deleteDieSize(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchiveDieSize = createAsyncThunk(
    'dieSize/unArchiveDieSize',
    async (id, thunkAPI) => {
        try {
            await dieSizeService.unArchiveDieSize(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);


const initialState = {
    data: [],  // Ensure the data is always an empty array initially
    list: [],
    loading: false,
    totalRecord: 0,
    totalPages: 0,
    currentPage: 1,
    status: 'idle',
    error: null,
    hasMore: true,
};

const dieSizeSlice = createSlice({
    name: 'diesize',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetDieSizeList: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentDieSizePage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDieSizeList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDieSizeList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Correctly access the data array
                state.totalRecord = action.payload.count || 0; // Set total records
                state.totaldie = action?.payload?.results?.total_die_count || 0;
                state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchDieSizeList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchDieSizeDropdown.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDieSizeDropdown.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Correctly access the data array
                state.totalRecord = action.payload.count || 0; // Set total records
                state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchDieSizeDropdown.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchArchivedDieSizeList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedDieSizeList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Correctly access the data array
                state.totalRecord = action.payload.count || 0; // Set total records
                state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedDieSizeList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(createDieSize.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createDieSize.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createDieSize.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });

        builder
            .addCase(editDieSize.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(editDieSize.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const index = state.data.findIndex((Size) => Size.id === action.payload.id);
                if (index !== -1) {
                    state.data[index] = action.payload; // Update the die size in the state
                }
            })
            .addCase(editDieSize.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deleteDieSize.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteDieSize.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteDieSize.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveDieSize.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveDieSize.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveDieSize.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const { resetDieSizeList, resetCurrentDieSizePage } = dieSizeSlice.actions;
const { reducer } = dieSizeSlice;
export default reducer;
